import { Button, Col } from "antd";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import Table from "../../../shared/components/ui/Table";
import { TableColumns } from "../../../shared/components/ui/Table/types";
import { storesService } from "../../../shared/services";
import React from "react";
import { useDeleteStore } from "../hooks";

export type StoreRow = {
  id: number;
  name: string;
  address: string;
  location_city_id: number;
  phone: string;
  is_pick_and_go?: string;
  latitude?: number | null;
  longitude?: number | null;
};

export const TableStores = ({
  setOpenModalEdit,
  setStoreId,
}: {
  setOpenModalEdit: (v: boolean) => void;
  setStoreId: React.Dispatch<React.SetStateAction<number | undefined>>;
}) => {
  const { setTableProps, showDeleteConfirm } = useDeleteStore();

  const columns: TableColumns<StoreRow> = [
    {
      title: "ID",
      width: 2,
      dataIndex: "id",
      key: "id",
      filterType: "text",
    },
    {
      title: "Nombre",
      width: 4,
      dataIndex: "name",
      key: "name",
      filterType: "text",
    },
    {
      title: "Ciudad (id)",
      width: 2,
      dataIndex: "location_city_id",
      key: "location_city_id",
      filterType: "text",
    },
    {
      title: "Dirección",
      width: 4,
      dataIndex: "address",
      key: "address",
      filterType: "text",
    },
    {
      title: "Teléfono",
      width: 3,
      dataIndex: "phone",
      key: "phone",
      filterType: "text",
    },
    {
      title: "Recogida en tienda",
      width: 3,
      dataIndex: "is_pick_and_go",
      key: "is_pick_and_go",
      render: (v: string | undefined) =>
        v === "si" ? "Sí" : v === "no" ? "No" : v ?? "—",
    },
    {
      title: "Acciones",
      key: "operation",
      width: 3,
      render: (_, item) => (
        <Col
          style={{
            display: "flex",
            width: "100%",
            justifyContent: "space-evenly",
            flexDirection: "row",
          }}
        >
          <Button
            type="primary"
            shape="circle"
            icon={<EditOutlined />}
            size="large"
            onClick={() => {
              setStoreId(item.id);
              setOpenModalEdit(true);
            }}
          />
          <Button
            type="primary"
            danger
            shape="circle"
            icon={<DeleteOutlined />}
            size="large"
            onClick={() => showDeleteConfirm(item.id, item.name)}
          />
        </Col>
      ),
    },
  ];

  return (
    <Table<StoreRow>
      columns={columns}
      scroll={{}}
      fetchQueryProps={{
        $sort: { id: -1 },
      }}
      service={storesService}
      onLoad={setTableProps}
    />
  );
};
